<template>
    <div class="content">
        <div class="section">
            <div class="left-box">
                <div
                    class="title flex-row"
                    :class="navTab == 0 ? 'activeBG' : ''"
                    @click="changeTab(0)"
                >
                    门票订单
                    <img src="../assets/img/icon-choosed.svg" v-if="navTab == 0" />
                </div>
                <!-- <div class="title flex-row" :class="navTab==1?'activeBG':''" @click="changeTab(1)">
					发票开取
					<img src="../assets/img/icon-choosed.svg" v-if="navTab==1">
				</div> -->
            </div>
            <div class="right-box">
                <div class="userinfo flex-row">
                    <img class="avatar" src="../assets/img/icon-avatar.png" />
                    <div class="info">
                        {{ teamInfo.teamName }}
                        <div class="tip">四川大学博物馆欢迎您</div>
                    </div>
                </div>
                <div class="order" v-if="navTab == 0">
                    <div class="nav flex-row">
                        <div
                            class="nav-item cursorp"
                            :class="currentTab == index ? 'activeNav' : ''"
                            v-for="(item, index) in navList"
                            :key="index"
                            @click="changeNav(index)"
                        >
                            {{ item }}
                        </div>
                    </div>
                    <div class="table" v-if="lists.list.length > 0">
                        <div v-for="(item, index) in tableTitle" :key="index">{{ item }}</div>
                    </div>
                    <div class="list">
                        <div class="item" v-for="(item, index) in lists.list" :key="index">
                            <div class="title">
                                订单编号：{{ item.orderSn }}
                                <span>下单时间：{{ item.createTime }}</span>
                            </div>
                            <div class="goods flex-row">
                                <div class="i1 flex-row">
                                    <img class="icon-avatar" src="../assets/img/icon-avatar.png" />
                                    <div class="name ellipsis1">
                                        四川大学博物馆团队门票
                                        <div class="flex-row">
                                            <!-- <div v-for="(item,index) in item.mainOrderItemVOS" :key="index">
												{{item.productName}}<span>x{{item.productQuantity}}</span></div>&nbsp;&nbsp;&nbsp; -->
                                            <span>x{{ item.orderQuantity }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="i2 flex-column">
                                    参观时间
                                    <div v-if="item.museumTeamItemOrderDOs">
                                        {{ item.museumTeamItemOrderDOs[0].playStartDay }}
                                    </div>
                                </div>
                                <div class="i3 flex-column">
                                    <div style="color: #e34d59" v-if="item.orderStatus == 0">
                                        待支付
                                    </div>
                                    <div
                                        style="color: #bb2916"
                                        v-if="item.orderStatus == 1 || item.orderStatus == 12"
                                    >
                                        待使用
                                    </div>
                                    <!-- 	<div style="color:#BB2916" v-if="item.orderStatus==12">
										待激活
									</div> -->
                                    <div style="color: #bb2916" v-if="item.orderStatus == 2">
                                        已使用
                                    </div>
                                    <div style="color: #e34d59" v-if="item.orderStatus == 3">
                                        已取消
                                    </div>
                                    <div style="color: #e34d59" v-if="item.orderStatus == 4">
                                        已退票
                                    </div>
                                    <div style="color: #b57c0b" v-if="item.orderStatus == 6">
                                        审核中
                                    </div>
                                    <span style="color: #a6a6a6" v-if="item.orderStatus == 4"
                                        >订单金额，已原路返还</span
                                    >
                                    <span style="color: #a6a6a6" v-if="item.orderStatus == 3"
                                        >订单超时，未支付</span
                                    >
                                    <div style="color: #e34d59" v-if="item.orderStatus == 7">
                                        审核未通过
                                    </div>
                                    <div
                                        class="paybtn cursorp"
                                        v-if="item.orderStatus == 0"
                                        @click="toPage(item.orderStatus, item.orderSn)"
                                    >
                                        立即支付
                                    </div>
                                </div>
                                <div class="i4 flex-column">
                                    ￥{{ item.totalAmount }}
                                    <div
                                        class="paymode flex-row"
                                        v-if="
                                            item.orderStatus != 0 &&
                                            item.orderStatus != 6 &&
                                            item.orderStatus != 7
                                        "
                                    >
                                        <img
                                            :src="
                                                item.paymentMethod == 4
                                                    ? require('../assets/img/icon-rmb.png')
                                                    : require('../assets/img/icon-juhe.png')
                                            "
                                            alt=""
                                            v-if="item.paymentMethod != null"
                                        />
                                        {{
                                            item.paymentMethod == null
                                                ? ""
                                                : item.paymentMethod == 4
                                                ? "数字人民币"
                                                : "聚合支付"
                                        }}
                                    </div>
                                </div>
                                <div class="i5 flex-column">
                                    <div
                                        class="lookbtn cursorp"
                                        @click="toPage(item.orderStatus, item.orderSn)"
                                    >
                                        查看
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="notData flex-column" v-if="lists.list.length == 0 && show">
                        <img src="../assets/img/icon-qszw.png" />
                        <div>暂无任何订单数据</div>
                    </div>
                </div>
                <div class="invoice" v-if="navTab == 1">
                    <div class="nav flex-row">
                        <div
                            class="nav-item"
                            :class="currentTab == index ? 'activeNav' : ''"
                            v-for="(item, index) in navInvoice"
                            :key="index"
                            @click="changeNav(index)"
                        >
                            {{ item }}
                        </div>
                    </div>
                    <div class="list">
                        <el-checkbox-group
                            v-model="checkedOrder"
                            @change="handleCheckedCitiesChange"
                        >
                            <div class="item" v-for="(item, index) in lists.list" :key="index">
                                <div class="title" v-if="currentTab == 0">
                                    <el-checkbox :label="item.orderSn"
                                        >订单编号：{{ item.orderSn }}</el-checkbox
                                    >
                                </div>
                                <div class="title" v-if="currentTab == 1">
                                    订单编号：{{ item.orderSn }}
                                </div>
                                <div class="goods flex-row">
                                    <div class="i1 flex-row">
                                        <img
                                            class="icon-avatar"
                                            src="../assets/img/icon-avatar.png"
                                        />
                                        <div class="name ellipsis1">
                                            四川大学博物馆团队门票
                                            <div v-show="currentTab == 0">
                                                <!-- 普通票<span>x2</span>、学生票<span>x1</span> -->
                                                x{{ item.orderQuantity }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="i2 flex-column" v-show="currentTab == 0">
                                        下单日期
                                        <div>
                                            {{ item.createTime }}
                                        </div>
                                    </div>
                                    <div class="i2 flex-column" v-show="currentTab == 1">
                                        旅游服务
                                        <div>电子发票</div>
                                    </div>
                                    <div class="i4 flex-column">
                                        ￥{{ currentTab == 0 ? item.totalAmount : item.totalPrice }}
                                    </div>
                                    <div class="i5 flex-column">
                                        <!-- <router-link to="InvoiceInfo"> -->
                                        <div
                                            class="lookbtn"
                                            v-show="currentTab == 0"
                                            @click="openInvoice(item.totalAmount, item.orderSn)"
                                        >
                                            申请开票
                                        </div>
                                        <!-- </router-link> -->
                                        <div
                                            class="againbtn"
                                            v-show="item.changeStateFlag == 0"
                                            @click="
                                                openInvoice(item.totalPrice, item.orderSn, item.id)
                                            "
                                        >
                                            申请重开
                                        </div>
                                        <div
                                            class="detail"
                                            v-show="currentTab == 1"
                                            @click="invoiceDetail(item.id)"
                                        >
                                            发票详情
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-checkbox-group>
                    </div>
                    <div class="notData flex-column" v-if="lists.list.length == 0 && show">
                        <img src="../assets/img/icon-qszw.png" />
                        <div>暂无任何订单数据</div>
                    </div>
                </div>
                <div
                    class="page flex-row"
                    :style="
                        navTab == 1 && currentTab == 0
                            ? 'justify-content: space-between'
                            : 'justify-content: flex-end'
                    "
                >
                    <div class="checkall flex-row" v-show="navTab == 1 && currentTab == 0">
                        <el-checkbox
                            :indeterminate="isIndeterminate"
                            v-model="checkAll"
                            @change="handleCheckAllChange"
                        >
                            全选</el-checkbox
                        >
                        <span class="totalPrice">￥{{ totalPrice }}</span>
                        <div class="invoicebtn" @click="openAllInvoice">合并开票</div>
                    </div>
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        @current-change="changePage"
                        @prev-change="changePage"
                        @next-click="changePage"
                        :current-page="lists.page"
                        :page-size="lists.limit"
                        :total="total"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
        <Tips :isShowTips="visibleDig" @changeDialog="getData"></Tips>
    </div>
</template>

<script>
import { getOrderList, merchantNo, getInvoiceList, checkIsTeam } from "@/utils/http.js";
import Tips from "@/components/Dialog/Tips";
import Api from "@/utils/common";
export default {
    components: {
        Tips,
    },
    data() {
        return {
            navList: ["全部订单", "待支付", "待使用", "已退票"],
            navInvoice: ["未开发票", "开票历史"],
            currentTab: 0,
            tableTitle: ["门票", "时间", "状态", "门票金额", "操作"],
            navTab: 0,
            lists: {
                list: [],
                page: 1,
                limit: 5,
            },
            visibleDig: false,
            checkAll: false,
            isIndeterminate: true,
            // 订单参数
            orderParam: {},
            paymentMethod: {
                0: "现金",
                1: "支付宝",
                2: "微信",
                3: "银联",
                4: "数字人民币",
            }, // 支付方式配置信息
            total: 0,
            checkedOrder: [], //选中订单号
            totalPrice: 0,
            show: false,
            teamInfo: {},
        };
    },
    // 被 keep-alive 缓存的组件激活时调用。
    activated() {
        console.log(555, this.navTab, this.currentTab);
        this.checkIsTeam();
        // 获取订单列表
        if (this.navTab == 0) {
            // 门票订单
            let date = Api.getDate();
            let nextDate = Api.getNextMonth(date);
            let orderStatusArray = "";
            switch (this.currentTab) {
                case 0:
                    orderStatusArray = "";
                    break;
                case 1:
                    orderStatusArray = 0;
                    break;
                case 2:
                    orderStatusArray = "1,12";
                    break;
                case 3:
                    orderStatusArray = "1,12";
                    break;
                default:
                    break;
            }
            this.getOrderList({
                orderStatusArray: orderStatusArray,
                orderType: 1,
                page: this.lists.page,
                limit: this.lists.limit,
                startTime: date,
                endTime: nextDate,
            });
        } else {
            // 发票订单
            this.getInvoiceList(
                {
                    page: 1,
                    limit: this.lists.limit,
                },
                this.currentTab,
            );
        }
    },
    methods: {
        // 获取订单列表
        getOrderList(param) {
            getOrderList(param).then(res => {
                console.log(res, "/resresres");
                let listData = this.lists;
                listData.list = res.data.rows;
                listData.page = param.page;
                this.total = res.data.total;
                this.show = true;
            });
        },
        // 获取开票订单列表
        getInvoiceList(param, tab) {
            getInvoiceList(param, tab).then(res => {
                let listData = this.lists;
                listData.list = res.data.rows;
                listData.page = param.page;
                this.total = res.data.total;
                this.show = true;
            });
        },
        // 查询团队认证状态
        checkIsTeam(param) {
            checkIsTeam(param).then(res => {
                this.teamInfo = res.data;
                // 还未认证或还未审核通过显示团队认证弹框
                if (res.data.stateFlag != 1) {
                    if (res.data.teamName != null && res.data.teamName != "") {
                        // 团队名称不为空，表示已经提交认证，在审核中，否则是还未提交认证
                        this.visibleDig = true;
                        localStorage.setItem("isExamine", 1);
                    } else {
                        localStorage.setItem("isExamine", 0);
                        this.visibleDig = true;
                    }
                } else {
                    //通过审核时将isExamine设置为1 展示审核页面
                    localStorage.setItem("isExamine", 1);
                    // 更新本地团队类型
                    localStorage.setItem("teamType", res.data.teamType);
                    this.teamType = res.data.teamType;
                }
            });
        },
        //切换页码,调用接口拉取数据
        changePage(current) {
            // 清空数据
            let listData = this.lists;
            listData.list = [];
            this.lists = listData;
            if (this.navTab == 0) {
                //设置订单列表请求参数
                this.orderParam = {
                    0: {
                        orderStatusArray: "",
                        orderType: 1, //订单类型（团队订单）
                        page: current,
                        limit: this.lists.limit, //全部订单
                    },
                    1: {
                        orderStatusArray: 0,
                        orderType: 1,
                        page: current,
                        limit: this.lists.limit, //待支付
                    },
                    2: {
                        orderStatusArray: "1,12",
                        orderType: 1,
                        page: current,
                        limit: this.lists.limit, //待使用
                    },
                    3: {
                        orderStatusArray: 4,
                        orderType: 1,
                        page: current,
                        limit: this.lists.limit, //已退款
                    },
                };
                // 调用获取订单列表接口
                this.getOrderList(this.orderParam[this.currentTab]);
            } else {
                this.getInvoiceList(
                    {
                        page: current,
                        limit: this.lists.limit,
                    },
                    this.currentTab,
                );
            }
        },
        // 点击侧边导航栏切换数据
        changeTab(val) {
            this.navTab = val;
            if (val == 1) {
                this.currentTab = 0;
            }
            this.changeNav(this.currentTab);
        },
        changeNav(val) {
            this.currentTab = val;
            // 清空数据
            let listData = this.lists;
            listData.list = [];
            listData.page = 1;
            this.lists = listData;
            if (this.navTab == 0) {
                //设置订单列表请求参数
                this.orderParam = {
                    0: {
                        // orderStatusArray: '',
                        orderType: 1, //订单类型（团队订单）
                        page: this.lists.page,
                        limit: this.lists.limit, //全部订单
                    },
                    1: {
                        orderStatusArray: 0,
                        orderType: 1,
                        page: this.lists.page,
                        limit: this.lists.limit, //待支付
                    },
                    2: {
                        orderStatusArray: "1,12",
                        orderType: 1,
                        page: this.lists.page,
                        limit: this.lists.limit, //待使用
                    },
                    3: {
                        orderStatusArray: 4,
                        orderType: 1,
                        page: this.lists.page,
                        limit: this.lists.limit, //已退款
                    },
                };
                // 调用获取订单列表接口
                this.getOrderList(this.orderParam[this.currentTab]);
            } else {
                this.getInvoiceList(
                    {
                        page: 1,
                        limit: this.lists.limit,
                    },
                    this.currentTab,
                );
            }
        },
        // 跳转发票详情
        invoiceDetail(id) {
            this.$router.push({
                path: "invoiceDetail",
                query: {
                    id: id, //点击重开数据id
                },
            });
        },
        // 点击单个申请开票
        openInvoice(price, orderNO, id) {
            let orderNoArr = [orderNO];
            this.$router.push({
                name: "InvoiceInfo",
                params: {
                    orderNo: orderNoArr, //订单号
                    totalPrice: price, //订单总价
                    id: id, //点击重开数据id
                },
            });
        },
        // 点击合并开票
        openAllInvoice() {
            if (this.checkedOrder.length == 0) {
                this.$message({
                    message: "请先勾选需要开票的订单！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            this.$router.push({
                name: "InvoiceInfo",
                params: {
                    orderNo: this.checkedOrder,
                    totalPrice: this.totalPrice,
                },
            });
        },
        // 点击全选
        handleCheckAllChange(val) {
            let OrderNoArr = [];
            let list = this.lists.list;
            let totalPrice = 0;
            if (val) {
                // 全选筛出所有产品id设置到选中数组中
                for (let li of list) {
                    OrderNoArr.push(li.orderSn);
                    totalPrice = (parseFloat(totalPrice) + li.totalAmount).toFixed(2);
                }
                this.totalPrice = totalPrice;
            } else {
                this.totalPrice = 0;
            }
            this.checkedOrder = val ? OrderNoArr : [];
            this.isIndeterminate = false;
        },
        // 点击单选
        handleCheckedCitiesChange(value) {
            console.log(value);
            let totalPrice = 0;
            let listData = this.lists.list;
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.lists.list.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.lists.list.length;
            // 计算勾选订单总价
            for (let li of listData) {
                if (value.indexOf(li.orderSn) != -1) {
                    totalPrice = (parseFloat(totalPrice) + li.totalAmount).toFixed(2);
                }
            }
            this.totalPrice = totalPrice;
        },
        // 获取子组件传过来的值
        getData(val) {
            this.visibleDig = val;
        },
        //点击查看详情
        toPage(orderStatus, orderNo) {
            if (orderStatus == 0) {
                // 待支付
                this.$router.push({
                    path: "TeamUnPay",
                    query: {
                        orderNo: orderNo,
                    },
                });
                return;
            }
            if (orderStatus == 1 || orderStatus == 12) {
                // 待使用
                this.$router.push({
                    path: "TeamUnused",
                    query: {
                        orderNo: orderNo,
                    },
                });
                return;
            }
            if (orderStatus == 6) {
                // 待审核
                this.$router.push({
                    path: "OrderReview",
                    query: {
                        orderNo: orderNo,
                    },
                });
                return;
            }
            if (orderStatus == 2 || orderStatus == 3 || orderStatus == 4) {
                // 已使用、已取消、已退款
                this.$router.push({
                    path: "TeamUsed",
                    query: {
                        orderNo: orderNo,
                    },
                });
                return;
            }
            if (orderStatus == 7) {
                // 审核失败
                this.$router.push({
                    path: "OrderReview",
                    query: {
                        orderNo: orderNo,
                    },
                });
                return;
            }
        },
    },
};
</script>

<style scoped>
.content {
    width: 1200px;
    background: #fff;
    background-size: 100% 100%;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
    margin: auto;
    padding: 24px;
    box-sizing: border-box;
}
.icon-avatar {
    width: 68px;
    height: 66px;
    background: #ffffff;
    border-radius: 6px 6px 6px 6px;
    border: 1px solid #d6d6d6;
}
.table {
    display: flex;
}
.table div:nth-child(1) {
    width: 31%;
}
.table div:nth-child(2) {
    width: 19%;
}
.table div:nth-child(3) {
    width: 19%;
}
.table div:nth-child(4) {
    width: 15%;
}
.table div:nth-child(5) {
    width: 15%;
}
.table div {
    height: 40px;
    line-height: 40px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    text-align: center;
    font-style: normal;
    text-transform: none;
}
.section {
    height: 100%;
    display: flex;
    flex-direction: row;
}

.content .left-box {
    width: 192px;
    height: 100%;
    /* height: 1120px; */
    position: relative;
}

/* 侧边导航栏激活样式 */
.activeBG {
    background: #bb2916 !important;
    border: 1px solid #fff !important;
    color: #fff !important;
}

.left-box .title {
    width: 192px;
    height: 55px;
    background: #f2f2f2;
    font-size: 16px;
    font-family: Source Han Serif SC-Regular, Source Han Serif SC;
    font-weight: 400;
    color: #333333;
    line-height: 55px;
    padding: 0 14px;
    box-sizing: border-box;
    justify-content: space-between;
}

.left-box .title img {
    width: 19px;
    height: 20px;
}

.content .right-box {
    width: 944px;
    height: 100%;
    /* height: 1120px; */
    position: relative;
}

.right-box .userinfo {
    width: 944px;
    height: 140px;
    background: #f2f2f2;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: 24px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: Source Han Serif SC-Regular, Source Han Serif SC;
    font-weight: 400;
    color: #333333;
    margin-bottom: 24px;
}

.right-box .userinfo img {
    width: 122px;
    height: 122px;
}

.right-box .userinfo .tip {
    font-size: 14px;
    font-family: Source Han Serif SC-Regular, Source Han Serif SC;
    font-weight: 400;
    color: #333333;
    margin-top: 10px;
}

.nav {
    justify-content: space-between;
    border-bottom: 2px solid #e7e7e7;
}

.nav-item {
    height: 50px;
    flex: 1;
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    text-align: center;
    line-height: 50px;
}

/* 导航栏激活样式 */
.activeNav {
    background: #bb2916;
    color: #fff !important;
}

.right-box .list {
    height: 40vh;
    overflow-y: scroll;
    overflow-x: hidden;
}

.list .title {
    width: 944px;
    height: 40px;
    background: #f4f4f4;
    /* border-radius: 6px 6px 0px 0px; */
    padding: 0 24px;
    box-sizing: border-box;
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 40px;
}

.list .title span {
    margin-left: 44px;
}

.list .goods {
    width: 942px;
    height: 121px;
    background: #ffffff;
    border: 1px solid #efefef;
}

.list .item {
    margin-bottom: 10px;
}

.list .goods .i1 {
    width: 294px;
    height: 100%;
    border-right: 1px solid #efefef;
    padding: 0 24px;
    box-sizing: border-box;
}

.list .goods .i1 img {
    width: 68px;
    height: 66px;
    border-radius: 6px;
    margin-right: 13px;
}

.goods .i1 .name {
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
    color: #333333;
    width: 165px;
}

.i1 .name div {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    margin-top: 12px;
}

.i1 .name div span {
    color: #333333;
}

.list .i2 {
    width: 194px;
    height: 100%;
    border-right: 1px solid #efefef;
    /* padding: 0 22px; */
    box-sizing: border-box;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    justify-content: center;
}

.list .i2 div {
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
    color: #333333;
    margin-top: 14px;
}

.list .i3 {
    width: 154px;
    height: 100%;
    border-right: 1px solid #efefef;
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    justify-content: center;
}

.list .i3 div {
    margin-bottom: 12px;
}

.list .i3 .paybtn {
    width: 74px;
    height: 24px;
    background: linear-gradient(90deg, #00aa7a 0%, #00aa7a 0%, #027b56 100%) rgba(0, 0, 0, 0.2);
    border-radius: 16px;
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 24px;
    text-align: center;
}

.list .i4 {
    width: 140px;
    height: 100%;
    border-right: 1px solid #efefef;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    justify-content: center;
}

.list .i4 .paymode {
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
    color: #000000;
    margin-top: 10px;
}

.list .i4 .paymode img {
    width: 24px;
    height: 24px;
    margin-right: 6px;
}

.list .i5 {
    width: 158px;
    height: 100%;
    justify-content: center;
}

.list .i5 .lookbtn {
    width: 74px;
    height: 40px;
    background: #ba2a17;
    border-radius: 6px;
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    text-align: center;
    line-height: 40px;
}

.i5 .againbtn {
    width: 74px;
    height: 40px;
    background: #ba2a17;
    border-radius: 6px;
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    text-align: center;
    line-height: 40px;
}

.i5 .detail {
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #bb2916;
    margin-top: 12px;
}

.right-box .page {
    margin-top: 24px;
    justify-content: space-between;
}

.invoice .i2 {
    width: 349px !important;
}

.checkall .invoicebtn {
    width: 86px;
    height: 32px;
    border-radius: 6px;
    border: 1px solid #bb2916;
    line-height: 32px;
    text-align: center;
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #bb2916;
    margin-left: 12px;
}
.avatar {
    width: 102px !important;
    height: 102px !important;
    border-radius: 50%;
    margin-left: 10px;
    border: 3px solid #bb2916;
    margin-right: 10px;
}
.totalPrice {
    font-size: 18px;
    font-weight: 600;
    color: #bb2916;
    margin-left: 12px;
}

/deep/ .el-menu {
    border: none;
    border: 1px solid #e7e7e7;
}

/deep/.el-submenu__title:hover {
    background: #f4f4f4 !important;
}

/deep/.el-menu-item:hover {
    background: #f4f4f4 !important;
}

/deep/ .el-submenu .el-menu-item {
    text-align: left;
    min-width: 0 !important;
    background: #ffffff;
    color: #333333 !important;
    padding-left: 20px !important;
    font-size: 14px;
}

/deep/.el-menu-item:focus {
    color: #bb2916 !important;
    font-weight: 600;
}

/deep/ .page .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #bb2916;
    border-color: #bb2916;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: unset;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #bb2916;
    border-color: #bb2916;
    border-color: #bb2916;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #bb2916;
    border-color: #bb2916;
    border-color: #bb2916;
}

/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
    color: #bb2916;
}

/deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #bb2916;
    border-color: #bb2916;
}

/deep/ .el-checkbox__inner:hover {
    border-color: #bb2916 !important;
}
</style>
